import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormFeedback,
} from 'reactstrap';

const ExplorerInputModal = ({
  isOpen,
  title,
  label,
  initialValue = '',
  confirmText = 'OK',
  onCancel,
  onConfirm,
}) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue);
      setError('');
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.select();
        }
      }, 0);
    }
  }, [isOpen, initialValue]);

  const submit = () => {
    const next = (value || '').trim().replace(/^\/+/, '');
    if (!next) {
      setError('Path is required');
      return;
    }
    if (next.includes('..')) {
      setError('Invalid path');
      return;
    }
    onConfirm(next);
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} size="sm">
      <ModalHeader toggle={onCancel}>{title}</ModalHeader>
      <ModalBody>
        {/* {label ? <label className="small text-muted d-block mb-1">{label}</label> : null} */}
        <Input
          innerRef={inputRef}
          value={value}
          invalid={Boolean(error)}
          onChange={(e) => {
            setValue(e.target.value);
            setError('');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submit();
          }}
        />
        {error ? <FormFeedback className="d-block">{error}</FormFeedback> : null}
      </ModalBody>
      <ModalFooter>
        <Button size="sm" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="sm" color="primary" onClick={submit}>
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExplorerInputModal;
